export default "__VITE_ASSET__a6494642__"